// extracted by mini-css-extract-plugin
export var downArrow = "_86-0";
export var infoTooltipIcon = "_86-3";
export var label = "_86-1";
export var optionCard = "_86-4";
export var upArrow = "_86-2";